"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Telemetry = void 0;
var lodash_1 = __importDefault(require("lodash"));
var GetFullName_1 = __importDefault(require("@CommonFrontendBackend/Utils/GetFullName"));
var PlansOrder_1 = __importDefault(require("@CommonFrontendBackend/Utils/PlansOrder"));
var fingerprint_1 = require("@qwilr/fingerprint");
var Deferred_1 = require("@CommonFrontend/Utils/Deferred/Deferred");
var Telemetry = (function () {
    function Telemetry($log, environment, user, account, utils, initialiseFullstory, rolesService, segmentDisabled, fingerprintPublicKey) {
        var _this = this;
        this.$log = $log;
        this.environment = environment;
        this.user = user;
        this.account = account;
        this.utils = utils;
        this.rolesService = rolesService;
        this.fingerprintPublicKey = fingerprintPublicKey;
        this.anonymousId = new Deferred_1.Deferred();
        this.debounceList = [];
        if (!!(analytics === null || analytics === void 0 ? void 0 : analytics.debug)) {
            analytics.debug(false);
        }
        if (segmentDisabled) {
            this.segment = mockSegment;
        }
        else {
            this.segment = analytics;
        }
        this.initialising = new Promise(function (resolve) {
            if (typeof (analytics === null || analytics === void 0 ? void 0 : analytics.ready) === "function") {
                analytics === null || analytics === void 0 ? void 0 : analytics.ready(function () { return __awaiter(_this, void 0, void 0, function () {
                    var fingerprintId;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, (0, fingerprint_1.getFingerprintId)(this.fingerprintPublicKey)];
                            case 1:
                                fingerprintId = _a.sent();
                                if (fingerprintId) {
                                    analytics.user().anonymousId(fingerprintId);
                                }
                                this.anonymousId.resolve(analytics.user().anonymousId());
                                resolve();
                                return [2];
                        }
                    });
                }); });
            }
            else {
                resolve();
            }
        });
        initialiseFullstory();
    }
    Telemetry.prototype.getAuthAttrs = function () {
        return __awaiter(this, void 0, Promise, function () {
            var anonymousId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.anonymousId.promise];
                    case 1:
                        anonymousId = _a.sent();
                        return [2, {
                                anon_user_id: anonymousId,
                                has_anon_id: Boolean(anonymousId),
                                auth_user_id: this.user._id,
                                is_auth: Boolean(this.user._id),
                            }];
                }
            });
        });
    };
    Telemetry.prototype.track = function (event, parameters, options) {
        return __awaiter(this, void 0, Promise, function () {
            var modifiers, propertyName, propertyValue, authAttrs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.initialising];
                    case 1:
                        _a.sent();
                        this.utils.assert(event != null && event.length, "No event name given to Analytics");
                        modifiers = this.getSegmentIntegrationSelectors(options);
                        if (!!!parameters) return [3, 4];
                        for (propertyName in parameters) {
                            propertyValue = parameters[propertyName];
                            if (lodash_1.default.includes(["first_name", "last_name", "name"], propertyName)) {
                                continue;
                            }
                            if (!!(propertyValue === null || propertyValue === void 0 ? void 0 : propertyValue.toLowerCase) && !lodash_1.default.includes(AVOID_LOWERCASE_LIST, propertyName)) {
                                parameters[propertyName] = propertyValue.toLowerCase();
                            }
                            if (typeof propertyValue === "boolean") {
                                parameters[propertyName] = propertyValue ? "true" : "false";
                            }
                        }
                        if (!(options === null || options === void 0 ? void 0 : options.includeAuthAttrs)) return [3, 3];
                        return [4, this.getAuthAttrs()];
                    case 2:
                        authAttrs = _a.sent();
                        Object.assign(parameters, authAttrs);
                        _a.label = 3;
                    case 3:
                        if (!options || !options.blockIdentify) {
                            this.segmentUpdate(this.user, parameters, modifiers);
                        }
                        _a.label = 4;
                    case 4:
                        if (this.environment !== "production") {
                            this.$log.info("Sending event:", event, parameters || "");
                        }
                        this.segmentTrack(event, parameters, modifiers);
                        return [2];
                }
            });
        });
    };
    Telemetry.prototype.update = function (properties, options) {
        return __awaiter(this, void 0, Promise, function () {
            var modifiers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.initialising];
                    case 1:
                        _a.sent();
                        try {
                            this.$log.info("Updating:", properties);
                            modifiers = this.getSegmentIntegrationSelectors(options);
                            this.segmentUpdate(this.user, properties, modifiers);
                        }
                        catch (e) {
                            this.$log.error(e);
                        }
                        return [2];
                }
            });
        });
    };
    Telemetry.prototype.identify = function (user, account, parameters) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.initialising];
                    case 1:
                        _a.sent();
                        try {
                            this.segmentIdentify(user, account, parameters);
                        }
                        catch (e) {
                            this.$log.error(e);
                        }
                        return [2];
                }
            });
        });
    };
    Telemetry.prototype.flushHubspot = function () {
        if (typeof analytics !== "undefined" && analytics !== null) {
            this.segment.page(undefined, undefined, {}, {
                integrations: {
                    All: false,
                    HubSpot: true,
                },
            });
        }
    };
    Telemetry.prototype.shouldBlockChurnZero = function () {
        var planNames = (0, PlansOrder_1.default)();
        var isPayingAccount = planNames.includes(this.account.plan.displayName);
        return !isPayingAccount;
    };
    Telemetry.prototype.group = function (properties, options, callback) {
        return __awaiter(this, void 0, Promise, function () {
            var modifiers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.initialising];
                    case 1:
                        _a.sent();
                        try {
                            if (this.environment !== "production") {
                                this.$log.info("Identifying group:", properties);
                            }
                            modifiers = this.getSegmentIntegrationSelectors(options);
                            properties.block_churn_zero = this.shouldBlockChurnZero();
                            this.segmentGroup(this.account, properties, modifiers, callback);
                        }
                        catch (e) {
                            this.$log.error(e);
                        }
                        return [2];
                }
            });
        });
    };
    Telemetry.prototype.pageHit = function (category, name, properties) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.initialising];
                    case 1:
                        _a.sent();
                        try {
                            this.segmentPage(category, name, properties);
                        }
                        catch (e) {
                            this.$log.error(e);
                        }
                        return [2];
                }
            });
        });
    };
    Telemetry.prototype.debouncedTrack = function (event, parameters, options, debounceInterval) {
        var _this = this;
        if (debounceInterval === void 0) { debounceInterval = 60000; }
        var debounceInstance = this.debounceList.find(function (debounceObj) { return debounceObj.event === event; });
        if (debounceInstance) {
            debounceInstance.fn(event, parameters, options);
        }
        else {
            var newDebounceFn = lodash_1.default.debounce(function (event, parameters, options) {
                _this.track(event, parameters, options);
            }, debounceInterval, {
                leading: true,
                trailing: false,
            });
            this.debounceList.push({
                fn: newDebounceFn,
                event: event,
            });
            newDebounceFn(event, parameters, options);
        }
    };
    Telemetry.prototype.segmentTrack = function (eventName, properties, options) {
        if (!!analytics) {
            var newProperties = lodash_1.default.assign({}, properties, {
                user_id: "".concat(this.user._id),
                account_id: "".concat(this.account._id),
            });
            this.segment.track(eventName, newProperties, options);
        }
    };
    Telemetry.prototype.segmentIdentify = function (user, account, options) {
        var name = (0, GetFullName_1.default)(user);
        if (!!analytics) {
            var createdDate = new Date(user.createdAt);
            this.segment.identify(user._id, {
                created: "".concat(createdDate.toDateString(), " ").concat(createdDate.toTimeString()),
                created_unix: createdDate.getTime(),
                email: user.email,
                email_billing: "",
                name: name,
                first_name: user.firstName,
                last_name: user.lastName,
                phone: account.phoneNumber,
                user_type: this.rolesService.isAdmin(user) ? "admin" : "creator",
            }, options);
        }
    };
    Telemetry.prototype.segmentGroup = function (account, properties, options, callback) {
        if (!!analytics) {
            this.segment.group(account._id, properties, options, callback);
        }
    };
    Telemetry.prototype.segmentUpdate = function (user, properties, options) {
        if (!!analytics) {
            this.segment.identify(user._id, properties, options);
        }
    };
    Telemetry.prototype.segmentPage = function (category, name, properties) {
        if (!!analytics) {
            this.segment.page(category, name, properties);
        }
    };
    Telemetry.prototype.getSegmentIntegrationSelectors = function (options) {
        var modifiers = {};
        if (!!options) {
            if (modifiers.integrations == null) {
                modifiers.integrations = {};
            }
            if (options.blockIntercom) {
                modifiers.integrations.Intercom = false;
            }
            if (options.blockNonMarketing) {
                modifiers.integrations.All = false;
                modifiers.integrations["Google AdWords New"] = true;
                modifiers.integrations["Google Tag Manager"] = true;
                modifiers.integrations["Facebook Pixel"] = true;
            }
            if (options.blockNonDev) {
                modifiers.integrations.All = false;
            }
        }
        return modifiers;
    };
    return Telemetry;
}());
exports.Telemetry = Telemetry;
var AVOID_LOWERCASE_LIST = [
    "stripe_customer_id",
    "subscriber_tool_switching_to",
    "subscriber_tool_switching_to_reason",
    "subscriber_tool_switching_from",
    "subscriber_tool_switching_from_reason",
];
var mockSegment = {
    page: function () { },
    track: function () { },
    identify: function () { },
    group: function () { },
};
